import type from 'type-detect';

class EventRegister {
    static listeners = {
        count: 0,
        refs: {},
    };

    static addEventListener(eventName: string, callback: Function) {
        if (
            type(eventName) === 'string'
            && type(callback) === 'function'
        ) {
            EventRegister.listeners.count++;
            const eventId = `l${EventRegister.listeners.count}`;
            EventRegister.listeners.refs[eventId] = {
                name: eventName,
                callback,
            };
            return eventId;
        }
        return false;
    }

    static removeEventListener(id: any) {
        if (type(id) === 'string') {
            return delete EventRegister.listeners.refs[id];
        }
        return false;
    }

    static removeAllListeners() {
        let removeError = false;
        Object.keys(EventRegister.listeners.refs).forEach((_id) => {
            const removed = delete EventRegister.listeners.refs[_id];
            removeError = (!removeError) ? !removed : removeError;
        });
        return !removeError;
    }

    static emitEvent(eventName: string, data?: any) {
        Object.keys(EventRegister.listeners.refs).forEach((_id) => {
            if (
                EventRegister.listeners.refs[_id]
                && eventName === EventRegister.listeners.refs[_id].name
            ) EventRegister.listeners.refs[_id].callback(data);
        });
    }

    /*
    * shortener
    */
    static on(eventName: string, callback: Function) {
        return EventRegister.addEventListener(eventName, callback);
    }

    static rm(eventName: string) {
        return EventRegister.removeEventListener(eventName);
    }

    static rmAll() {
        return EventRegister.removeAllListeners();
    }

    static emit(eventName: string, data?: any) {
        EventRegister.emitEvent(eventName, data);
    }
}

export { EventRegister };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/event-listeners.ts